import { render, staticRenderFns } from "./ProductAddToWishlist.vue?vue&type=template&id=2938b309&scoped=true"
import script from "./ProductAddToWishlist.vue?vue&type=script&lang=ts"
export * from "./ProductAddToWishlist.vue?vue&type=script&lang=ts"
import style0 from "./ProductAddToWishlist.vue?vue&type=style&index=0&id=2938b309&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2938b309",
  null
  
)

export default component.exports